// api.js
import { axiosInstance } from '../../helpers/api_helper';

const changePassword = async (formData: any) => {
  try {
    console.log('FormData in changePassword:', formData);

    const response = await axiosInstance.patch('/Admin/UpdatePassword', formData);

    console.log('API Response from changePassword:', response);

    // Check the structure of the response
    console.log('Response Data:', response.data);

    if (response.data && response.data.status === '00') {
      return response.data;
    } else {
      console.error('Unexpected API Response:', response);
      throw new Error('Error changing password');
    }
  } catch (error) {
    console.error('Error in changePassword:', error);
    throw error;
  }
};

export { changePassword };
